<script lang="ts">
  import { slide } from "svelte/transition";
  import Add from "../assets/icons/add.svg";
  import Minus from "../assets/icons/minus.svg";

  export let open = false;

  const handleClick = () => (open = !open);
</script>

<div class="my-4 p-4 rounded-xl bg-[--color-grayscale-20]">
  <div class:mb-2={open}>
    <button on:click={handleClick} class="flex w-full gap-2">
      {#if open}
        <img src={Minus} alt="collapse" class="w-6 h-6" />
      {:else}
        <img src={Add} alt="expand" class="w-6 h-6" />
      {/if}
      <slot name="head"></slot>
    </button>
  </div>

  {#if open}
    <div class="details" transition:slide>
      <slot name="details"></slot>
    </div>
  {/if}
</div>
